import { useState, forwardRef } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Input, type InputProps } from '@/v2/design-system/primitives';

/**
 * Sober DS (v2) — PasswordField (Story 27.29). Password input with a show/hide
 * toggle (PasswordFieldToggle). The toggle is a native button with aria-label;
 * no colored border — focus ring only.
 */
export const PasswordField = forwardRef<HTMLInputElement, Omit<InputProps, 'type'>>(
  ({ className, ...props }, ref) => {
    const [show, setShow] = useState(false);
    return (
      <div className="relative">
        <Input ref={ref} type={show ? 'text' : 'password'} className={cn('pr-10', className)} {...props} />
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          aria-label={show ? 'Ocultar senha' : 'Mostrar senha'}
          className="absolute right-0 top-1/2 grid size-11 -translate-y-1/2 place-items-center rounded-so-sm text-sober-secondary transition-colors hover:bg-sober-muted focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-sober-primary [&_svg]:size-4"
        >
          {show ? <EyeOff /> : <Eye />}
        </button>
      </div>
    );
  }
);
PasswordField.displayName = 'PasswordField';
